import { ref } from 'vue';
import ApiService from '../services/api.service';
import AlertService from '../services/errors.service';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const shouldRefresh = ref(false);
export default function useProjects() {
  const Projects = ref({});
  const Project = ref([]);
  const deletedProjectId = ref(null);
  const router = useRouter();
  const store = useStore();
  const isLoadingProject = ref(false);

  const getProjects = async (query) => {
    return await ApiService.get('/project/list?' + new URLSearchParams(query));
    // Projects.value = response.data;
  };
  const toggleShouldRefresh = () => {
    shouldRefresh.value = !shouldRefresh.value;
  };
  const getProject = async (id) => {
    let response = await ApiService.get('/project/single/' + id);
    Project.value = response.data.data;
  };
  const getProjectTag = async (id) => {
    return await ApiService.get('/project/tags?' + id);
  };
  const createProjectTag = async (id, tags) => {
    let payload = {
      project_id: id,
      name: tags
    };
    return await ApiService.post('/project/tags', payload);
  };
  const deleteProjectTag = async (id) => {
    return await ApiService.delete('/project/tags/' + id);
  };
  const editProjectTag = async (id, tags) => {
    let payload = {
      name: tags
    };
    return ApiService.patch('/project/tags/' + id, payload);
  };

  const getProjectEditData = async (id) => {
    let response = await ApiService.get('/project/' + id + '/edit');
    Project.value = response.data.data;
  };

  const storeProject = async (data) => {
    isLoadingProject.value = true;
    await ApiService.post('/project', data)
      .then((response) => {
        store.dispatch('auth/getUsersData');
        toggleShouldRefresh();
        redirectAndShowMessage(response.data.message);
      })
      .finally(() => {
        setTimeout(() => {
          isLoadingProject.value = false;
        }, 1000);
      });
  };

  function redirectAndShowMessage(msg) {
    AlertService.successMessage(msg);
    setTimeout(() => {
      router.push('/projects');
    }, 1000);
  }

  const updateProject = async (id, data) => {
    isLoadingProject.value = true;
    await ApiService.post('project/update/' + id, data)
      .then((response) => {
        store.dispatch('auth/getUsersData');
        toggleShouldRefresh();
        redirectAndShowMessage(response.data.message);
      })
      .finally(() => {
        setTimeout(() => {
          isLoadingProject.value = false;
        }, 1000);
      });
  };

  const destroyProject = async (id) => {
    try {
      const response = await ApiService.delete('/project/' + id);

      if (response.status === 200) {
        store.dispatch('auth/getUsersData');
        toggleShouldRefresh();
        AlertService.successMessage(response.data.message);
        deletedProjectId.value = response.data.id;
      }
    } catch (error) {}
  };

  return {
    Project,
    isLoadingProject,
    Projects,
    shouldRefresh,
    toggleShouldRefresh,
    deleteProjectTag,
    createProjectTag,
    editProjectTag,
    deletedProjectId,
    getProject,
    getProjectEditData,
    getProjects,
    storeProject,
    getProjectTag,
    updateProject,
    destroyProject
  };
}
